import { useCreateEvent } from "@/features/events/hooks/useCreateEvent"
import { EventType as NewEventType } from "@/features/events/types/EventType"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { saveEvent } from "../../../utils/apis/user-service"
import { EventType } from "../../../utils/enums/EventType"
import { useAuthStore } from "../../../utils/stores/useAuthStore"
import { useUserStore } from "../../../utils/stores/useUserStore"
import BackButton from "../components/BackButton"
import { FolderCategory } from "../components/enums"
import FolderBox from "../components/Folder"

const TestsAndReports = () => {
    const { sendEvent } = useCreateEvent()
    const { auth } = useAuthStore()
    const idToken = auth.idToken
    const userId = auth.userId
    const { userData } = useUserStore()
    const email = userData.email
    const navigate = useNavigate()

    const folderConfig = [
        {
            folder: FolderCategory.DNATest,
            eventType: EventType.DnaTestFolderClicked,
            route: "dna-test",
            metadata: "",
        },
        {
            folder: FolderCategory.BloodExams,
            eventType: EventType.BloodTestFolderClicked,
            route: "blood-test",
            metadata: "",
        },
        {
            folder: FolderCategory.HealthAssessment,
            eventType: EventType.HealthAssessmentFolderClicked,
            route: "/health-assessment",
            metadata: "",
        },
        {
            folder: FolderCategory.UploadedForYou,
            eventType: EventType.UploadedForYouFolderClicked,
            route: "uploaded-for-you",
            metadata: "",
        },
        {
            folder: FolderCategory.UploadedFromYou,
            eventType: EventType.UploadedFromYouFolderClicked,
            route: "uploaded-from-you",
            metadata: "",
        },
    ];

    if (userId === "2f2bc4a7-3aa0-4f19-910c-332cf03f4c48") {
        folderConfig.push({
            folder: FolderCategory.Emr,
            eventType: EventType.UploadedFromYouFolderClicked,
            route: "emr",
            metadata: "",
        });
    }

    const handleFolderClick = async (route: string, eventType: EventType, metadata: string) => {
        navigate(route);
        if (!email) return;
        saveEvent(
            email,
            eventType,
            (success) => console.log(success),
            (error) => console.log(error),
            "tests_and_reports_page"
        );
        await sendEvent({
            event: NewEventType.CLICK,
            sub_category: "open_test_and_reports_folder",
            event_metadata: { folder: metadata }
        })
    };

    useEffect(() => {
        if (!email) return
        saveEvent(
            email,
            EventType.PageView,
            (success) => { console.log() },
            (error) => { console.log(error) },
            "tests_and_reports_page",
        )

        void sendEvent({
            event: NewEventType.PAGE_VIEW,
            sub_category: "tests_and_reports_page",
        })
    }, [])

    // ********************************************************************************

    return (
        <div className="w-full h-full flex flex-col space-y-[20px]">
            <div className="mt-[10px] space-y-[10px]">
                <BackButton
                    text="Torna a Diagnostica"
                    onClick={() => navigate("/diagnostica")}
                />
                <div className="font-bold text-[25px] leading-[33px]">
                    Test e referti
                </div>
            </div>
            <div className="font-normal text-[16px] leading-[26px]">
                In questa cartella puoi accedere a tutti i documenti condivisi con la tua Medical Equipe,
                oltre ai risultati dei tuoi test e alle risposte alle domande che ti vengono sottoposte
                con i questionari.
            </div>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                {folderConfig.map(({ folder, eventType, route, metadata }) => (
                    <FolderBox
                        key={folder}
                        folder={folder}
                        onClick={() => handleFolderClick(route, eventType, metadata)}
                    />
                ))}
            </div>
            <div className="p-[10px]" />
        </div>
    )
}

export default TestsAndReports
